import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  TextInput,
} from "components/Input/Index.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import { batiment } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import {  NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddEquipmentDialog(props) {
  const [prevData, setPrevData] = useState();
  const [name, setName] = useState("");
  const [clef, setClef] = useState("");
  const [type, setType] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, energy, parameters, deleteCounter } = props;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleClefChange = (event) => { setClef(event.target.value); };
  const handleTypeChange = (event) => { setType(event.target.value); };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "renewables.equipmentlist"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevData(res.data.detail?.renewables?.equipmentlist || []);
      });
  }, [deleteCounter]);

  const handleSubmit = async (event) => {
    let equipments = prevData;
    const newEquipments = {
      name,
      clef,
      type,
      'uuid': uuid(),
    };
    equipments.push(newEquipments);

    axios
      .put(
        getSite(chartIdGroup, "renewables.equipmentlist"),
        equipments,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Equipement ajouté");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        closeModal();
        refetch();
        deleteCounter();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const typeData = [
    { name: "PV", id: "pv" },
    { name: "Solaire thermique", id: "solar" },
    { name: "Eolien", id: "wind" },
    { name: "Biomasse", id: "biomass" },
    { name: "Géothermie", id: "geothermal" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={batiment.renewables.equipmentlist.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={batiment.renewables.equipmentlist.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.renewables.equipmentlist.type}
                selectValue={type}
                handleSelectValueChange={handleTypeChange}
                data={typeData}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={false} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddEquipmentDialog;
